import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PasswordService } from '../profile.service';
import { Password, PasswordForm } from '../model/model.class';
import { Router } from '@angular/router';
import { MatSelect, MatSnackBar } from '@angular/material';
import { AppComponentClass } from '../../shared/service/AppComponent.class';

@Component({
  selector: 'app-passwordchange',
  templateUrl: './passwordchange.component.html',
  styleUrls: ['./passwordchange.component.css']
})
export class PasswordchangeComponent extends AppComponentClass<Password, PasswordForm> {
  public loader: boolean;
  public spinner: boolean;
  form: FormGroup;
  key: number;
  password;
  oldshow = true;
  newshow = true;
  confirmshow = true;
  submitted: boolean = false;
  constructor(protected data: PasswordService, protected router: Router, protected fb: FormBuilder, protected msg: MatSnackBar) {
    super(data, router, fb, msg);
    this.spinner = true;
    this.loader = false;
  }

  // ShowHidePwdOld() {
  //   if (this.password === 'password') {
  //     this.password = 'text';
  //     this.oldshow = true;
  //   } else {
  //     this.password = 'password';
  //     this.oldshow = false;
  //   }
  // }

  
 


  ngOnInit() {
    super.ngOnInit();
    this.data.solution.subscribe(res => {
      if (res != null) {
        console.log("Update data " + JSON.stringify(res));
        this.cdata = new PasswordForm(res);
        this.keyfield = parseInt(sessionStorage.getItem('userid'));
        this.form = this.cdata.makeform(this.fb);
      }
      else {
        console.log("adding data " + JSON.stringify(res));
        this.cdata = new PasswordForm(null);
        this.keyfield = -1;
        this.form = this.cdata.makeform(this.fb);
      }
    });

    //-------Function for show and hide password Icone-------
    

  }

  onSubmit() {

    if (this.submitted = true) {
      this.key = parseInt(sessionStorage.getItem('userid'));

            if (this.form.value.newpassword == this.form.value.confirmpassword) {
              console.log("Thanks for Updating Change Password: " + JSON.stringify(this.form.value) + " With Param Key :" + this.key);
              this.data.updatePassword(JSON.stringify(this.form.value), this.key).subscribe(rs => {
                console.log(rs);
                this.openSnackBar(rs.message, "Clear");
                this.form.reset();
              });
            }
         
        else {
          this.openSnackBar("Your entered confirm password does not match", "Clear");
        }
      
    }
  }



}




export function ConfirmPasswordValidator(controlName: string, matchingControlName: string) {
  return (formGroup: FormGroup) => {
    let control = formGroup.controls[controlName];
    let matchingControl = formGroup.controls[matchingControlName]
    if (
      matchingControl.errors &&
      !matchingControl.errors.confirmPasswordValidator
    ) {
      return;
    }
    if (control.value !== matchingControl.value) {
      matchingControl.setErrors({ confirmPasswordValidator: true });
    } else {
      matchingControl.setErrors(null);
    }
  };



}


